import { IResult } from '../types/IResponse';
import { ISiteSAMLAttributeMapping } from '../types/ISiteSAMLConfiguration';
import { Request } from './Request';

export class SetSiteAttributeMappingRequest extends Request<ISiteSAMLAttributeMapping, IResult> {
  constructor(mapping: ISiteSAMLAttributeMapping) {
    super('setSiteAttributeMapping', mapping);
  }
}
